import { render, staticRenderFns } from "./CustomActionForm.vue?vue&type=template&id=0bffa33c"
import script from "./CustomActionForm.vue?vue&type=script&lang=js"
export * from "./CustomActionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports